
; /**
 * HWC-4153 round 4 - the video-widget half of site.js: thumbnail sizing/play flows, muted
 * autoplay (IntersectionObserver), and youtube/vimeo embed wiring. Only pages carrying a
 * video actually run any of it, so it ships as the 'video' site feature chunk: emitted
 * eagerly when the page markup reveals a video (SITE_JS_CHUNK_TRIGGERS), lazy-loaded by the
 * DOM probe in site.js otherwise (a snippet-embedded <video> is invisible to the markup
 * triggers - the probe checks the real DOM). Self-initializing: the $(function) below runs
 * immediately when the chunk arrives after DOM-ready (lazy path) and at DOM-ready on the
 * eager path. _isFeeEditing stays in site.js (CategoryTabSwitcher uses it too) and resolves
 * globally at call time - site.js always loads first.
 */
function syncVideoThumbnailHeight($thumb, vid) {
    if (!vid || !vid.videoWidth || !vid.videoHeight) return;
    var thumbW = $thumb[0].getBoundingClientRect().width || $thumb.outerWidth();
    if (thumbW) {
        $thumb.css('height', Math.round(thumbW * vid.videoHeight / vid.videoWidth) + 'px');
    }
}

function syncAllVideoThumbnailHeights() {
    $('video[custom-thumb="true"]').each(function() {
        var $vid = $(this);
        var $thumb = $vid.parent().find('.snippet-video-thumbnail');
        if (!$thumb.length) { return; }
        var savedAR = $vid.attr('data-video-aspect-ratio');
        if (savedAR) {
            var parts = savedAR.split(':');
            var pw = parseInt(parts[0], 10), ph = parseInt(parts[1], 10);
            if (pw && ph) {
                var thumbW = $thumb[0].getBoundingClientRect().width || $thumb.outerWidth();
                if (thumbW) { $thumb.css('height', Math.round(thumbW * ph / pw) + 'px'); }
            }
        } else if (!$vid.attr('data-video-height') && $vid[0]) {
            syncVideoThumbnailHeight($thumb, $vid[0]);
        }
    });
}
function initVideoAutoplay() {
    // Only run on published pages / Preview — never while editing in the FEE (any layout/context).
    if (_isFeeEditing()) { return; }
    $('[data-style-type="video"][data-video-autoplay="1"]').each(function() {
        var $vsEl = $(this);
        var $iframe = $vsEl.find('iframe').first();
        if (!$iframe.length) { return; } // native video: autoplay/muted/playsinline attrs handle it
        var src = $iframe.attr('src') || '';
        if (!src) { return; }
        var changed = false;
        // Ensure autoplay=1
        if (src.indexOf('autoplay=1') === -1) {
            src = src.indexOf('autoplay=') !== -1
                ? src.replace(/autoplay=\d+/, 'autoplay=1')
                : src + (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
            changed = true;
        }
        // Browser autoplay policy requires muted for cross-origin iframes with audio.
        // YouTube param: mute=1 — Vimeo param: muted=1
        var isVimeo = ($vsEl.attr('data-video-type') === 'vimeo') || (src.indexOf('vimeo.com') !== -1);
        var muteParam = isVimeo ? 'muted' : 'mute';
        if (src.indexOf(muteParam + '=1') === -1) {
            src = src.indexOf(muteParam + '=') !== -1
                ? src.replace(new RegExp(muteParam + '=\\d+'), muteParam + '=1')
                : src + '&' + muteParam + '=1';
            changed = true;
        }
        if (!changed) { return; }
        var existingAllow = ($iframe.attr('allow') || '').trim();
        if (existingAllow.indexOf('autoplay') === -1) {
            $iframe.attr('allow', existingAllow ? existingAllow + '; autoplay' : 'autoplay');
        }
        $iframe.attr('src', src);
    });
}

function initVideoThumbnailPlay() {
    $('[custom-thumb="true"]').each(function() {
        var $el = $(this);
        var $parent = $el.parent();
        var $thumb = $parent.find('.snippet-video-thumbnail');
        if ($thumb.length) {
            $el.hide();
            $thumb.show();
            if ($el.is('video')) {
                var vid = $el[0];
                var savedAR = $el.attr('data-video-aspect-ratio');
                var savedH = $el.attr('data-video-height');
                if (savedAR) {
                    var parts = savedAR.split(':');
                    var pw = parseInt(parts[0], 10), ph = parseInt(parts[1], 10);
                    if (pw && ph) {
                        var thumbW = $thumb[0].getBoundingClientRect().width || $thumb.outerWidth();
                        if (thumbW) { $thumb.css('height', Math.round(thumbW * ph / pw) + 'px'); }
                    }
                } else if (savedH) {
                    $thumb.css('height', parseInt(savedH, 10) + 'px');
                } else if (vid) {
                    if (vid.readyState >= 1) {
                        syncVideoThumbnailHeight($thumb, vid);
                    } else {
                        vid.addEventListener('loadedmetadata', function() {
                            syncVideoThumbnailHeight($thumb, vid);
                        }, { once: true });
                    }
                }
            }
        }
    });

    var _thumbResizeTimer;
    $(window).off('resize.videoThumb').on('resize.videoThumb', function() {
        clearTimeout(_thumbResizeTimer);
        _thumbResizeTimer = setTimeout(syncAllVideoThumbnailHeights, 150);
    });

    $(document).on('click', '.snippet-video-thumbnail', function() {
        var $thumb = $(this);
        // One-shot flag set by initVideoWidgetAutoplay() when it replays this flow at page
        // load: scripted (no-gesture) playback must be muted to satisfy browser autoplay policy.
        var autoplayMuted = $thumb.data('wcAutoplayMuted') === true;
        $thumb.removeData('wcAutoplayMuted');
        var $thumbParent = $thumb.parent();
        var $el = $thumbParent.is('[custom-thumb]') ? $thumbParent : $thumbParent.find('[custom-thumb]').first();
        var $vid = $thumbParent.find('video').first();
        if (!$vid.length) { $vid = $thumbParent.find('iframe').first(); }
        var isIframe = $vid.is('iframe');
        var isLightbox = $el.attr('video-lightbox') === 'true';

        if (isLightbox) {
            var _lbShowControls = $el.attr('data-video-show-controls') !== '0';
            var _lbAllowFs = $el.attr('data-video-allow-fullscreen') !== 'no';
            var _lbShowInfo = $el.attr('data-video-show-info') !== '0';
            var _lbVideoType = $el.attr('data-video-type') || '';

            function _setLbParam(url, param, value) {
                var re = new RegExp('([?&])' + param + '=[^&]*');
                if (re.test(url)) { return url.replace(re, '$1' + param + '=' + value); }
                return url + (url.indexOf('?') !== -1 ? '&' : '?') + param + '=' + value;
            }

            if (!isIframe) {
                var videoSrc = $vid.attr('src') || ($vid.find('source').first().attr('src') || '');
                var _lbCtrlsList = $vid.attr('controlsList') || '';
                var $overlay = $(
                    '<div class="wc-video-lightbox-overlay">' +
                    '<div class="wc-video-lightbox-overlay-content">' +
                    '<button class="wc-video-lightbox-close">&times;</button>' +
                    '<div class="wc-video-lightbox-content">' +
                    '<video class="wc-video-lightbox-video" src="' + videoSrc + '"' +
                        (_lbShowControls ? ' controls' : '') +
                        (_lbCtrlsList ? ' controlsList="' + _lbCtrlsList + '"' : '') +
                    '></video>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                );
                $('body').append($overlay);
                setTimeout(function() {
                    $overlay.addClass('wc-video-lightbox-active');
                    var $lv = $overlay.find('.wc-video-lightbox-video');
                    if ($lv.length) { $lv[0].play(); }
                }, 10);

                function closeLightbox() {
                    var $lightboxVid = $overlay.find('.wc-video-lightbox-video');
                    if ($lightboxVid.length) { $lightboxVid[0].pause(); }
                    $overlay.removeClass('wc-video-lightbox-active');
                    setTimeout(function() { $overlay.remove(); }, 300);
                }

                $overlay.find('.wc-video-lightbox-close').on('click', closeLightbox);
                $overlay.on('click', function(e) {
                    if ($(e.target).is($overlay)) { closeLightbox(); }
                });
            } else {
                var iframeSrc = $vid.attr('src') || '';
                iframeSrc = iframeSrc.indexOf('autoplay') !== -1
                    ? iframeSrc.replace(/autoplay=\d/, 'autoplay=1')
                    : iframeSrc + (iframeSrc.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
                if (!_lbShowControls) {
                    iframeSrc = _setLbParam(iframeSrc, 'controls', '0');
                }
                if (!_lbShowInfo && _lbVideoType === 'vimeo') {
                    iframeSrc = _setLbParam(iframeSrc, 'title', '0');
                    iframeSrc = _setLbParam(iframeSrc, 'byline', '0');
                }
                var _lbFsAttr = _lbAllowFs ? ' allowfullscreen' : '';
                var _lbAllowAttr = _lbAllowFs ? 'autoplay; fullscreen' : 'autoplay';
                var $iframeOverlay = $(
                    '<div class="wc-video-lightbox-overlay">' +
                    '<div class="wc-video-lightbox-overlay-content">' +
                    '<button class="wc-video-lightbox-close">&times;</button>' +
                    '<div class="wc-video-lightbox-content">' +
                    '<iframe src="' + iframeSrc + '"' + _lbFsAttr + ' frameborder="0" allow="' + _lbAllowAttr + '" style="width:100%;height:100%;min-height:360px;display:block;"></iframe>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                );
                $('body').append($iframeOverlay);
                setTimeout(function() { $iframeOverlay.addClass('wc-video-lightbox-active'); }, 10);

                function closeIframeLightbox() {
                    $iframeOverlay.find('iframe').attr('src', '');
                    $iframeOverlay.removeClass('wc-video-lightbox-active');
                    setTimeout(function() { $iframeOverlay.remove(); }, 300);
                }

                $iframeOverlay.find('.wc-video-lightbox-close').on('click', closeIframeLightbox);
                $iframeOverlay.on('click', function(e) {
                    if ($(e.target).is($iframeOverlay)) { closeIframeLightbox(); }
                });
            }
        } else {
            $thumb.hide();

            // Restore the thumbnail overlay (and play icon) once inline playback finishes,
            // so the widget returns to its poster state instead of resting on the ended player.
            var origIframeSrc = isIframe ? ($vid.attr('src') || '') : '';
            var restoreThumb = function() {
                if (!isIframe) {
                    if ($vid.length) {
                        try { $vid[0].pause(); $vid[0].currentTime = 0; } catch (e) {}
                    }
                    $vid.hide();
                } else {
                    // Reset the iframe src so playback stops and a re-click can replay it.
                    $vid.attr('src', origIframeSrc);
                    $el.hide();
                }
                $thumb.show();
            };

            if (!isIframe) {
                // Ensure controls are visible: the video may not have the `controls` attr
                // when "Show Controls" is OFF, but after clicking through an overlay the user
                // must be able to pause/seek — native controls are the only option here.
                if ($vid.length) {
                    $vid[0].style.removeProperty('pointer-events');
                    $vid[0].setAttribute('controls', '');
                }
                $vid.show();
                if ($vid.length) {
                    if (autoplayMuted) {
                        $vid.prop('muted', true).attr('playsinline', '');
                    }
                    var playPromise = $vid[0].play();
                    if (playPromise && playPromise.catch) { playPromise.catch(function() {}); }
                    $vid.off('ended.wcThumbRestore').on('ended.wcThumbRestore', restoreThumb);
                }
            } else {
                var isVimeoEmbed = origIframeSrc.indexOf('vimeo.com') !== -1;
                var src = origIframeSrc;
                src = src.indexOf('autoplay') !== -1
                    ? src.replace(/autoplay=\d/, 'autoplay=1')
                    : src + (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
                if (autoplayMuted) {
                    // YouTube param: mute=1 — Vimeo param: muted=1
                    var muteParam = isVimeoEmbed ? 'muted' : 'mute';
                    if (src.indexOf(muteParam + '=1') === -1) {
                        src = src.indexOf(muteParam + '=') !== -1
                            ? src.replace(new RegExp(muteParam + '=\\d+'), muteParam + '=1')
                            : src + '&' + muteParam + '=1';
                    }
                }
                // enablejsapi lets us hear the YouTube player's ENDED state via postMessage.
                if (!isVimeoEmbed && src.indexOf('enablejsapi=1') === -1) {
                    src += '&enablejsapi=1';
                }
                var existingAllow = ($vid.attr('allow') || '').trim();
                if (existingAllow.indexOf('autoplay') === -1) {
                    $vid.attr('allow', existingAllow ? existingAllow + '; autoplay' : 'autoplay');
                }
                // Register end-detection BEFORE swapping src so the iframe 'load' handshake fires.
                wireEmbedThumbnailRestore($vid[0], isVimeoEmbed, restoreThumb);
                $vid.attr('src', src);
                // Show the [data-style-type="video"] container — NOT just the iframe.
                // initVideoThumbnailPlay hides $el (the container div), so showing $vid
                // alone would leave the parent display:none and the iframe invisible.
                $el.show();
            }
        }
    });
}

// Video widget (.wc-video-container) autoplay — published page only. The widget GSP never
// bakes autoplay into the media markup (the same render is shown inside the FEE editor,
// where playback must not start); it emits data-video-autoplay="1" on the container and
// this function starts playback here, muted, since browser autoplay policy blocks
// un-muted playback without a user gesture.
function initVideoWidgetAutoplay() {
    // Never autoplay while editing in the FEE (any layout/context); published page + Preview only.
    if (_isFeeEditing()) { return; }
    var $containers = $('.wc-video-container[data-video-autoplay="1"]');
    if (!$containers.length) { return; }

    // Start playback only when the widget scrolls INTO the viewport, not instantly on page load.
    // IntersectionObserver fires on first observe if the element is already visible, so an
    // above-the-fold widget still plays immediately; a below-the-fold one waits until scrolled to.
    // One-shot per widget (unobserve after firing) so scrolling away and back does not restart it.
    if (typeof window.IntersectionObserver === 'function') {
        var observer = new IntersectionObserver(function(entries, obs) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) { return; }
                obs.unobserve(entry.target);
                _playVideoWidgetAutoplay($(entry.target));
            });
        }, { threshold: 0.25 });
        $containers.each(function() { observer.observe(this); });
    } else {
        // Fallback for browsers without IntersectionObserver: original immediate behavior.
        $containers.each(function() { _playVideoWidgetAutoplay($(this)); });
    }
}

// Starts muted playback for a single video-widget container. Split out from
// initVideoWidgetAutoplay() so the IntersectionObserver can invoke it per-widget when the
// widget enters the viewport. Playback semantics per media type are unchanged.
function _playVideoWidgetAutoplay($container) {
    var $media = $container.find('video, iframe').first();
    if (!$media.length) { return; }
    if ($media.attr('custom-thumb') === 'true') {
        // Image Overlay ON. Popup (lightbox) mode never auto-opens; inline mode replays
        // the thumbnail click flow so the overlay hides now and — via the existing
        // end-detection wiring — reappears when playback finishes.
        if ($media.attr('video-lightbox') === 'true') { return; }
        var $thumb = $container.find('.snippet-video-thumbnail').first();
        if (!$thumb.length) { return; }
        $thumb.data('wcAutoplayMuted', true);
        $thumb.trigger('click');
    } else if ($media.is('video')) {
        $media.prop('muted', true).attr('playsinline', '');
        var playPromise = $media[0].play();
        if (playPromise && playPromise.catch) { playPromise.catch(function() {}); }
    } else {
        var src = $media.attr('src') || '';
        if (!src) { return; }
        var isVimeo = src.indexOf('vimeo.com') !== -1;
        var muteParam = isVimeo ? 'muted' : 'mute';
        if (src.indexOf('autoplay=1') === -1) {
            src = src.indexOf('autoplay=') !== -1
                ? src.replace(/autoplay=\d+/, 'autoplay=1')
                : src + (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
        }
        if (src.indexOf(muteParam + '=1') === -1) {
            src = src.indexOf(muteParam + '=') !== -1
                ? src.replace(new RegExp(muteParam + '=\\d+'), muteParam + '=1')
                : src + '&' + muteParam + '=1';
        }
        var allow = ($media.attr('allow') || '').trim();
        if (allow.indexOf('autoplay') === -1) {
            $media.attr('allow', allow ? allow + '; autoplay' : 'autoplay');
        }
        $media.attr('src', src);
    }
}

function initEmbedVideoPlay() {
    $(document).on('click', 'video[data-embed-url]', function(e) {
        e.preventDefault();
        var $vid = $(this);
        var embedUrl = $vid.attr('data-embed-url');
        if (!embedUrl) { return; }
        var allowFs = $vid.attr('data-video-allow-fullscreen') !== 'no';
        var sep = embedUrl.indexOf('?') !== -1 ? '&' : '?';
        var $iframe = $('<iframe frameborder="0" style="width:100%;height:100%;display:block;min-height:270px;"></iframe>');
        if (allowFs) {
            $iframe.attr('allowfullscreen', '');
            $iframe.attr('allow', 'autoplay; fullscreen');
        } else {
            $iframe.attr('allow', 'autoplay');
        }
        $iframe.attr('src', embedUrl + sep + 'autoplay=1');
        $vid.replaceWith($iframe);
    });
}

// Detects when an embedded YouTube/Vimeo video finishes playing — via the player's
// postMessage API — and runs `onEnded` (used to restore the video thumbnail overlay).
// Best-effort: depends on the third-party player honouring the JS API.
function wireEmbedThumbnailRestore(iframe, isVimeo, onEnded) {
    if (!iframe || !iframe.contentWindow) { return; }
    var handled = false;
    var onMessage = function(e) {
        if (e.source !== iframe.contentWindow) { return; }
        var data = e.data;
        if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (err) { return; }
        }
        if (!data) { return; }
        var ended = false;
        if (isVimeo) {
            ended = (data.event === 'ended' || data.event === 'finish');
        } else if (data.event === 'onStateChange') {
            ended = (data.info === 0);                 // 0 === YT.PlayerState.ENDED
        } else if (data.event === 'infoDelivery' && data.info && data.info.playerState === 0) {
            ended = true;
        }
        if (ended && !handled) {
            handled = true;
            window.removeEventListener('message', onMessage);
            onEnded();
        }
    };
    window.addEventListener('message', onMessage);

    // Subscribe to player events once the autoplay src has loaded.
    iframe.addEventListener('load', function() {
        var win = iframe.contentWindow;
        if (!win) { return; }
        if (isVimeo) {
            win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'ended' }), '*');
            win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'finish' }), '*');
        } else {
            var id = iframe.id || 'wc-yt-player';
            win.postMessage(JSON.stringify({ event: 'listening', id: id, channel: 'widget' }), '*');
            win.postMessage(JSON.stringify({ event: 'command', func: 'addEventListener', args: ['onStateChange'], id: id, channel: 'widget' }), '*');
        }
    }, { once: true });
}

$(function() {
    if (typeof _isFeeEditing !== "function") { return; }
    initVideoAutoplay();
    initVideoThumbnailPlay();
    // Must run AFTER initVideoThumbnailPlay: it may replay the thumbnail click flow,
    // and initVideoThumbnailPlay's initial pass would re-hide the media element.
    initVideoWidgetAutoplay();
    initEmbedVideoPlay();
});
